import type { GameObj } from 'kaplay'
import type { KAPLAYCtx, FloorSceneOpts } from '../types.ts'
import loadSoundsAssets from '../assets/sounds.ts'
import loadSpriteAssets from '../assets/sprites.ts'
import { useRooms } from '../rooms/index.ts'
import { useFloors } from '../floors/index.ts'
import { useGameUiControls } from '../objects/game-ui-controls.ts'
import { useElevatorPopup } from '../objects/elevator-popup.ts'
import { usePlayer } from '../characters/player.ts'
import { getTiledSize } from '../utils.ts'

export function useFloor13Scene(k: KAPLAYCtx) {
  loadSoundsAssets(k)
  loadSpriteAssets(k)

  const {
    createGameUiControls,
    resizeGameUiControls,
    // destroyGameUiControls,
  } = useGameUiControls(k)

  const {
    showElevatorPopup,
    hideElevatorPopup,
  } = useElevatorPopup(k)

  let floor13: GameObj
  const { setFloor13 } = useFloors(k)

  k.scene('floor13', (opts?: FloorSceneOpts) => {
    let enterByStairsElevator = !!opts?.playerPos

    opts = opts || {}

    const {
      setWC,
      setWCB,
      setWCHandicap,
      setMeetingRoomJ,
      setMeetingRoomK,
      setMeetingRoomL,
      setMeetingRoomM,
    } = useRooms(k)

    const { setPlayer } = usePlayer(k)
    const player = opts?.playerPos
      ? setPlayer(k.vec2(opts.playerPos.x, opts.playerPos.y))
      : setPlayer(k.vec2(getTiledSize(25), getTiledSize(48)))

    // Camera follows player
    player.onUpdate(() => k.setCamPos(player.pos))

    floor13 = setFloor13()

    k.onCollide('floor_13_door','player', (door: GameObj) => {
      k.flash(k.BLACK, 0.5)
      floor13.destroy()
      k.play('sfx_door', { volume: 0.2 })

      if (door.tags.includes('floor_13_door_to_wc')) {
        setWC({
          onExit: () => {
            player.setPos(k.vec2(getTiledSize(15.5), getTiledSize(34)))
            floor13 = setFloor13()
          },
        })
      } else if (door.tags.includes('floor_13_door_to_wc_b')) {
        setWCB({
          onExit: () => {
            player.setPos(k.vec2(getTiledSize(64.5), getTiledSize(28)))
            floor13 = setFloor13()
          },
        })
      } else if (door.tags.includes('floor_13_door_to_wc_handicap')) {
        setWCHandicap({
          onExit: () => {
            player.setPos(k.vec2(getTiledSize(67), getTiledSize(39)))
            floor13 = setFloor13()
          },
        })
      } else if (door.tags.includes('floor_13_door_to_meeting_room_j')) {
        setMeetingRoomJ({
          onExit: () => {
            player.setPos(k.vec2(getTiledSize(6), getTiledSize(36)))
            floor13 = setFloor13()
          },
        })
      } else if (door.tags.includes('floor_13_door_to_meeting_room_k')) {
        setMeetingRoomK({
          onExit: () => {
            player.setPos(k.vec2(getTiledSize(6), getTiledSize(40)))
            floor13 = setFloor13()
          },
        })
      } else if (door.tags.includes('floor_13_door_to_meeting_room_l')) {
        setMeetingRoomL({
          onExit: () => {
            player.setPos(k.vec2(getTiledSize(8.5), getTiledSize(41)))
            floor13 = setFloor13()
          },
        })
      } else if (door.tags.includes('floor_13_door_to_meeting_room_m')) {
        setMeetingRoomM({
          onExit: () => {
            player.setPos(k.vec2(getTiledSize(10.5), getTiledSize(41)))
            floor13 = setFloor13()
          },
        })
      }
    })

    // Elevators
    k.onCollide('player', 'floor_13_elevator', () => {
      if(enterByStairsElevator) return
      showElevatorPopup()
    })
    k.onCollideEnd('player', 'floor_13_elevator', () => {
      if(enterByStairsElevator) return enterByStairsElevator = false
      hideElevatorPopup()
    })

    // Stairs
    k.onCollide('player', 'floor_13_stairs', () => {
      if(enterByStairsElevator) return
      showElevatorPopup({origin: 'stairs'})
    })
    k.onCollideEnd('player', 'floor_13_stairs', () => {
      if(enterByStairsElevator) return enterByStairsElevator = false
      hideElevatorPopup()
    })

    // SFX
    k.onCollide('player', 'door_exit', () => {
      k.play('sfx_door', { volume: 0.2 })
    })
    k.onCollide('player', 'colliders', () => {
      k.play('sfx_hurt', { volume: 0.1 })
    })
    k.onCollide('player', 'sfx_emit_action', () => {
      k.play('sfx_action', { volume: 0.5 })
    })

    k.loadSound('sfx_piano_1', 'sfx/piano-1.ogg')
    k.loadSound('sfx_piano_2', 'sfx/piano-2.ogg')
    k.loadSound('sfx_piano_3', 'sfx/piano-3.ogg')
    k.loadSound('sfx_piano_4', 'sfx/piano-4.ogg')
    k.loadSound('sfx_piano_5', 'sfx/piano-5.ogg')

    const sfxAssets = [
      'sfx_piano_1',
      'sfx_piano_2',
      'sfx_piano_3',
      'sfx_piano_4',
      'sfx_piano_5',
    ]

    k.onClick('floor_13_piano_easteregg', () => {
      const sfxPiano = sfxAssets[Math.floor(Math.random()*sfxAssets.length)]
      k.play(sfxPiano, { volume: 0.2 })
    })

    createGameUiControls()

    k.onLoad(()=>k.flash(k.BLACK, 1))
    k.onResize(() => resizeGameUiControls())

  })

}
